/** Split `name, other name` input into unique, lower-cased tag names (the API stores tags lower-cased, citext-unique). */
export function parseTagNames(input: string): string[] {
  const out: string[] = [];
  for (const raw of input.split(',')) {
    const n = raw.trim().toLowerCase();
    if (n && !out.includes(n)) out.push(n);
  }
  return out;
}
